import { useState, useEffect, useRef } from 'react';
import classsnames from 'classnames';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { color } from '../../app/theme';

const useStyles = makeStyles(
  () => ({
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      width: '100%',
      padding: '10.5px 16px 10.5px',
      borderRadius: 22,
      border: `1px solid ${color.$10}`,
      backgroundColor: color.$7,
    },
    'root--error': {
      borderColor: color.$17,
    },
    textarea: {
      display: 'block',
      flex: '1 1 auto',
      width: '100%',
      height: 21,
      fontSize: 15,
      lineHeight: '21px',
      outline: 'none',
      padding: 0,
      border: 'none',
      resize: 'none',
      overflow: 'hidden',
    },
    'textarea--error': {
      border: `1px solid ${color.$17}`,
    },
    wordCounter: {
      display: 'block',
      fontSize: 11,
      lineHeight: 1,
      color: color.$10,
      marginTop: 6.5,
    },
    'wordCounter--error': {
      color: color.$17,
    },
  }),
  {
    name: 'TextAreaCard',
  },
);

function TextAreaCard({
  status,
  value,
  maxCount,
  onChange,
  placeholder,
  filterName,
  disabled,
}) {
  const classes = useStyles();
  const [localValue, setLocalValue] = useState(value || '');
  const textareaRef = useRef(null);

  function handleChange(e) {
    const v = e.target.value;
    setLocalValue(v);
    onChange(v);
  }

  function lineController() {
    const dom = textareaRef.current;
    if (dom.value === '') {
      dom.style.height = '21px';
    } else {
      dom.style.height = 0;
      dom.style.height = `${dom.scrollHeight}px`;
    }
  }

  useEffect(() => {
    if (localValue !== value) {
      setLocalValue(value);
    }
  }, [value]);

  useEffect(() => {
    lineController();
  }, [localValue]);

  return (
    <div
      className={classsnames(classes.root, {
        [classes['root--error']]:
          localValue.replace(filterName, '').length > maxCount ||
          status === 'error',
      })}
    >
      <textarea
        ref={textareaRef}
        className={classes.textarea}
        placeholder={placeholder}
        value={localValue}
        onChange={e => handleChange(e)}
        disabled={disabled}
      />
      {maxCount > 0 && (
        <span
          className={classsnames(classes.wordCounter, {
            [classes['wordCounter--error']]:
              localValue.replace(filterName, '').length > maxCount,
          })}
        >
          {localValue.replace(filterName, '').length}/{maxCount}
        </span>
      )}
    </div>
  );
}

TextAreaCard.defaultProps = {
  value: '',
  maxCount: 0,
  onChange: () => {},
  placeholder: '',
  status: 'default',
  filterName: '',
};

TextAreaCard.propTypes = {
  value: PropTypes.string,
  maxCount: PropTypes.number,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  status: PropTypes.oneOf(['default', 'warning', 'error']),
  filterName: PropTypes.any,
};

export default TextAreaCard;
